import React from 'react'
import PropTypes from 'prop-types'
import IconButton from '#components/a/IconButton'

export default function FeedbackDownloadButton({downloadFile}) {
  return <IconButton event={downloadFile} icon="download" />
}

FeedbackDownloadButton.propTypes = {
  downloadFile: PropTypes.func.isRequired,
}
